import { useTranslation } from "react-i18next";

/**
 * Small inline spinner + label for any section that is still fetching.
 * Use it wherever content is awaited — a waiting section should show this,
 * never blank space or bare text.
 */
export function Loading({ label }: { label?: string }) {
  const { t } = useTranslation();
  return (
    <span className="loading" role="status">
      <span className="loading-spinner" aria-hidden="true" />
      {label ?? t("common.loading", "Loading…")}
    </span>
  );
}
